import { cn } from 'component-library';

import { UnitEnum } from '@/api/rest/resources/types/units';
import { FormControl, FormDescription, FormItem, FormLabel } from '@/components/Form';
import { Slider } from '@/components/widgets/a/Slider/Slider';

import { useControlsContext } from './Form';

type FormSliderProps = {
  formName: string;
  label?: string;
  helper?: string;
  min?: number;
  max?: number;
  step?: number;
  unit?: UnitEnum;
  showMinMax?: boolean;
  styles?: Record<string, string>;
};

export const FormSlider = ({ formName, label, helper, min, max, step, unit, showMinMax, styles }: FormSliderProps) => {
  const { setValue, watch } = useControlsContext();

  const value = watch(formName) ?? min ?? 0;

  const handleChange = (v: number) => {
    setValue(formName, v);
  };

  return (
    <FormItem className={cn(`flex flex-col gap-1 w-full`, styles?.root)}>
      <div className='flex items-center justify-between'>
        {label && <FormLabel className={cn('typography-body2 text-text-secondary', styles?.label)}>{label}</FormLabel>}
        <span className={cn('typography-body2 font-semibold text-text-primary ml-auto', styles?.value)}>{value}</span>
      </div>
      <FormControl>
        <Slider
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={handleChange}
          unit={unit}
          showMinMax={showMinMax}
        />
      </FormControl>
      {helper && <FormDescription className={cn(styles?.helper)}>{helper}</FormDescription>}
    </FormItem>
  );
};
